export function hasLinkedOAuth(user) {
  return Boolean(user?.vk_user_id || user?.google_user_id || user?.yandex_user_id)
}

export function userCanBeForcedToBindOAuth(user) {
  if (typeof user?.has_password === 'boolean') return user.has_password
  if (typeof user?.password_exists === 'boolean') return user.password_exists
  if (typeof user?.has_login_password === 'boolean') return user.has_login_password

  return !hasLinkedOAuth(user)
}

export function shouldForceOAuthBinding(user) {
  return Boolean(user?.force_oauth_login && !hasLinkedOAuth(user) && userCanBeForcedToBindOAuth(user))
}
